export enum ShopStatus {
  Active = 'active',
  Archive = 'archive',
  Internal = 'internal',
  Demo = 'demo'
}
